define.alias("shared/components/shared/profile-categorization/selected-types", "calendar/components/shared/profile-categorization/selected-types");